document.addEventListener("DOMContentLoaded", () => {
  const pirikaraButton = document.querySelector(".pirikara"); // class="pirikara"のボタンを取得
  const modalSelect = document.querySelector(
    'select[name="modal-variant-8074441425088"]'
  ); // 対象の<select>を取得

  // class="pirikara" をクリックした時の処理
  pirikaraButton.addEventListener("click", () => {
    if (modalSelect) {
      modalSelect.value = "45559611326656"; // ピリ辛セットのvalueを設定
      const event = new Event("change"); // onchangeイベントを発火させる
      modalSelect.dispatchEvent(event);
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const pirikaraButton = document.querySelector(".ookara"); // class="pirikara"のボタンを取得
  const modalSelect = document.querySelector(
    'select[name="modal-variant-8074441425088"]'
  ); // 対象の<select>を取得

  // class="pirikara" をクリックした時の処理
  pirikaraButton.addEventListener("click", () => {
    if (modalSelect) {
      modalSelect.value = "45559611261120"; // 大辛セットのvalueを設定
      const event = new Event("change"); // onchangeイベントを発火させる
      modalSelect.dispatchEvent(event);
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const pirikaraButton = document.querySelector(".gekikara"); // class="pirikara"のボタンを取得
  const modalSelect = document.querySelector(
    'select[name="modal-variant-8074441425088"]'
  ); // 対象の<select>を取得

  // class="pirikara" をクリックした時の処理
  pirikaraButton.addEventListener("click", () => {
    if (modalSelect) {
      modalSelect.value = "45566919377088"; // 激辛セットのvalueを設定
      const event = new Event("change"); // onchangeイベントを発火させる
      modalSelect.dispatchEvent(event);
    }
  });
});